import { CONFIGURATION_FEATURES_NAMES } from '~/Types';
import { isFeatureEnabled } from '~/Utils';

type Organization = Parameters<typeof isFeatureEnabled>[0];

/** Whether a claim opens on the Clive app claim page rather than the standard one. */
export const isCliveAppClaimPage = (organization: Organization): boolean =>
  isFeatureEnabled(organization, CONFIGURATION_FEATURES_NAMES.CLIVE_APP_CLAIM_PAGE);

/** Whether the standard claim page shows the configurable claim bar rather than the legacy one. */
export const isConfigurableClaimBarEnabled = (organization: Organization): boolean =>
  isFeatureEnabled(organization, CONFIGURATION_FEATURES_NAMES.CONFIGURABLE_FNOL);

/** Whether a claim page shows the configurable claim bar at all. */
export const isConfigurableClaimBarShown = (organization: Organization): boolean =>
  isConfigurableClaimBarEnabled(organization) && !isCliveAppClaimPage(organization);
